import { styled } from '../../../ui/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const Image = styled.img`
  width: 300px;
  height: auto;
`;
